/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UiRouteImport } from './routes/ui'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OwnerIndexRouteImport } from './routes/$owner.index'
import { Route as AuthErrorRouteImport } from './routes/auth/error'
import { Route as OwnerRepoIndexRouteImport } from './routes/$owner.$repo.index'
import { Route as OwnerRepoChar126RouteRouteImport } from './routes/$owner.$repo.~.route'
import { Route as OwnerRepoChar126ThreadsRouteImport } from './routes/$owner.$repo.~.threads'
import { Route as OwnerRepoChar126ChannelRouteImport } from './routes/$owner.$repo.~.$channel'

const UiRoute = UiRouteImport.update({
  id: '/ui',
  path: '/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnerIndexRoute = OwnerIndexRouteImport.update({
  id: '/$owner/',
  path: '/$owner/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnerRepoIndexRoute = OwnerRepoIndexRouteImport.update({
  id: '/$owner/$repo/',
  path: '/$owner/$repo/',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnerRepoChar126RouteRoute = OwnerRepoChar126RouteRouteImport.update({
  id: '/$owner/$repo/~',
  path: '/$owner/$repo/~',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnerRepoChar126ThreadsRoute = OwnerRepoChar126ThreadsRouteImport.update({
  id: '/threads',
  path: '/threads',
  getParentRoute: () => OwnerRepoChar126RouteRoute,
} as any)
const OwnerRepoChar126ChannelRoute = OwnerRepoChar126ChannelRouteImport.update({
  id: '/$channel',
  path: '/$channel',
  getParentRoute: () => OwnerRepoChar126RouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ui': typeof UiRoute
  '/auth/error': typeof AuthErrorRoute
  '/$owner/': typeof OwnerIndexRoute
  '/$owner/$repo/~': typeof OwnerRepoChar126RouteRouteWithChildren
  '/$owner/$repo/': typeof OwnerRepoIndexRoute
  '/$owner/$repo/~/$channel': typeof OwnerRepoChar126ChannelRoute
  '/$owner/$repo/~/threads': typeof OwnerRepoChar126ThreadsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ui': typeof UiRoute
  '/auth/error': typeof AuthErrorRoute
  '/$owner': typeof OwnerIndexRoute
  '/$owner/$repo/~': typeof OwnerRepoChar126RouteRouteWithChildren
  '/$owner/$repo': typeof OwnerRepoIndexRoute
  '/$owner/$repo/~/$channel': typeof OwnerRepoChar126ChannelRoute
  '/$owner/$repo/~/threads': typeof OwnerRepoChar126ThreadsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ui': typeof UiRoute
  '/auth/error': typeof AuthErrorRoute
  '/$owner/': typeof OwnerIndexRoute
  '/$owner/$repo/~': typeof OwnerRepoChar126RouteRouteWithChildren
  '/$owner/$repo/': typeof OwnerRepoIndexRoute
  '/$owner/$repo/~/$channel': typeof OwnerRepoChar126ChannelRoute
  '/$owner/$repo/~/threads': typeof OwnerRepoChar126ThreadsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ui'
    | '/auth/error'
    | '/$owner/'
    | '/$owner/$repo/~'
    | '/$owner/$repo/'
    | '/$owner/$repo/~/$channel'
    | '/$owner/$repo/~/threads'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ui'
    | '/auth/error'
    | '/$owner'
    | '/$owner/$repo/~'
    | '/$owner/$repo'
    | '/$owner/$repo/~/$channel'
    | '/$owner/$repo/~/threads'
  id:
    | '__root__'
    | '/'
    | '/ui'
    | '/auth/error'
    | '/$owner/'
    | '/$owner/$repo/~'
    | '/$owner/$repo/'
    | '/$owner/$repo/~/$channel'
    | '/$owner/$repo/~/threads'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  UiRoute: typeof UiRoute
  AuthErrorRoute: typeof AuthErrorRoute
  OwnerIndexRoute: typeof OwnerIndexRoute
  OwnerRepoChar126RouteRoute: typeof OwnerRepoChar126RouteRouteWithChildren
  OwnerRepoIndexRoute: typeof OwnerRepoIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/ui': {
      id: '/ui'
      path: '/ui'
      fullPath: '/ui'
      preLoaderRoute: typeof UiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$owner/': {
      id: '/$owner/'
      path: '/$owner'
      fullPath: '/$owner/'
      preLoaderRoute: typeof OwnerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/error': {
      id: '/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$owner/$repo/': {
      id: '/$owner/$repo/'
      path: '/$owner/$repo'
      fullPath: '/$owner/$repo/'
      preLoaderRoute: typeof OwnerRepoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$owner/$repo/~': {
      id: '/$owner/$repo/~'
      path: '/$owner/$repo/~'
      fullPath: '/$owner/$repo/~'
      preLoaderRoute: typeof OwnerRepoChar126RouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$owner/$repo/~/threads': {
      id: '/$owner/$repo/~/threads'
      path: '/threads'
      fullPath: '/$owner/$repo/~/threads'
      preLoaderRoute: typeof OwnerRepoChar126ThreadsRouteImport
      parentRoute: typeof OwnerRepoChar126RouteRoute
    }
    '/$owner/$repo/~/$channel': {
      id: '/$owner/$repo/~/$channel'
      path: '/$channel'
      fullPath: '/$owner/$repo/~/$channel'
      preLoaderRoute: typeof OwnerRepoChar126ChannelRouteImport
      parentRoute: typeof OwnerRepoChar126RouteRoute
    }
  }
}

interface OwnerRepoChar126RouteRouteChildren {
  OwnerRepoChar126ChannelRoute: typeof OwnerRepoChar126ChannelRoute
  OwnerRepoChar126ThreadsRoute: typeof OwnerRepoChar126ThreadsRoute
}

const OwnerRepoChar126RouteRouteChildren: OwnerRepoChar126RouteRouteChildren = {
  OwnerRepoChar126ChannelRoute: OwnerRepoChar126ChannelRoute,
  OwnerRepoChar126ThreadsRoute: OwnerRepoChar126ThreadsRoute,
}

const OwnerRepoChar126RouteRouteWithChildren =
  OwnerRepoChar126RouteRoute._addFileChildren(
    OwnerRepoChar126RouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  UiRoute: UiRoute,
  AuthErrorRoute: AuthErrorRoute,
  OwnerIndexRoute: OwnerIndexRoute,
  OwnerRepoChar126RouteRoute: OwnerRepoChar126RouteRouteWithChildren,
  OwnerRepoIndexRoute: OwnerRepoIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
